import { Container } from '../../../../../../../../components/container/container';
import { Select } from '../../../../../../../../components/select/select';
import { LangInput } from '../../../../../../../../features/lang-input/lang-input';
import { MultiSelect } from '../../../../../../../../features/multi-select/multi-select';
import { UserRole } from '../../../../../../../../store/api/manager-api';
import { useCompanyAdminsCreateModalStep1 } from './use-company-admins-create-modal-step-1';

export const CompanyAdminsCreateModalStep1 = () => {
  const { admin, branches, handleChangeInput, i18nRoles, t, handleUpdateAdmin, selectedRole } =
    useCompanyAdminsCreateModalStep1();

  return (
    <Container>
      <Container label={t('Имя')} required>
        <LangInput
          name="first_name"
          onChange={(value) => handleChangeInput('name', value)}
          value={admin?.name}
        />
      </Container>
      <Container label={t('Фамилия')} required>
        <LangInput
          name="last_name"
          onChange={(value) => handleChangeInput('surname', value)}
          value={admin?.surname}
        />
      </Container>

      <Container label={t('Роль')} required>
        <Select
          options={i18nRoles}
          name="role"
          onSelect={(e) => handleUpdateAdmin({ role: e.id as UserRole })}
          value={selectedRole}
        />
      </Container>
      {selectedRole?.id === 'admin_branch' && (
        <Container label={t('Филиалы')} required>
          <MultiSelect
            options={branches}
            name="branches"
            onSelect={(e) => handleUpdateAdmin({ branches: e.map((item) => +item.id) })}
            value={branches?.filter((item) => admin?.branches?.includes(+item.id))}
          />
        </Container>
      )}
    </Container>
  );
};
